// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__WffK1","search":"Settings_search__1vxme","filter":"Settings_filter__esrHe"};